import CheckList from "../pengecekan-form/CheckList";
import { getFotoFolderName } from "../../utils/editorHelpers";

const EditorCheckListCard = ({
  wrapperClassName,
  title,
  labelGrup,
  listProblemData,
  onProblemResolved,
  isBerangkat,
  modeAmbilGambar,
  setModeAmbilGambar,
  headerData,
  permittedToEdit,
  pengecekanPertama,
  pengecekanBerangkatData,
  setPengecekanBerangkatData,
  pengecekanKembaliData,
  setPengecekanKembaliData,
  pengecekanBerangkatDetilData,
  setPengecekanBerangkatDetilData,
  pengecekanKembaliDetilData,
  setPengecekanKembaliDetilData,
  handleOnClickDeskripsi,
  handleOnClickFotoRow,
  handleOnClickReload,
  handleOnClickSaveCheckList,
  loading,
  showBerangkat,
}) => {
  return (
    <div className={wrapperClassName}>
      <CheckList
        listProblemData={listProblemData}
        onProblemResolved={onProblemResolved}
        folderName={getFotoFolderName(headerData)}
        onClickDeskripsi={handleOnClickDeskripsi}
        onClickFotoRow={handleOnClickFotoRow}
        isBerangkat={isBerangkat}
        modeAmbilGambar={modeAmbilGambar}
        setModeAmbilGambar={setModeAmbilGambar}
        disabled={headerData.id && permittedToEdit ? false : true}
        // Save Bagian is blocked on the kembali page until Speedometer Kembali is filled in - the checklist
        // itself (checking rows, dialogs) stays usable, only the Save button is disabled
        saveDisabled={
          !isBerangkat && (!headerData.speedo_akhir || headerData.speedo_akhir <= 0)
        }
        title={title}
        labelGrup={labelGrup}
        pengecekanBerangkatData={
          pengecekanPertama ? {} : pengecekanBerangkatData
        }
        setPengecekanBerangkatData={setPengecekanBerangkatData}
        pengecekanKembaliData={pengecekanPertama ? {} : pengecekanKembaliData}
        setPengecekanKembaliData={setPengecekanKembaliData}
        pengecekanBerangkatDetilData={
          pengecekanPertama ? [] : pengecekanBerangkatDetilData
        }
        pengecekanKembaliDetilData={
          pengecekanPertama ? [] : pengecekanKembaliDetilData
        }
        setPengecekanBerangkatDetilData={setPengecekanBerangkatDetilData}
        setPengecekanKembaliDetilData={setPengecekanKembaliDetilData}
        onClickReload={handleOnClickReload}
        onClickSaveBerangkat={(detils) =>
          handleOnClickSaveCheckList({
            detils,
            type: "berangkat",
          })
        }
        onClickSaveKembali={(detils) =>
          handleOnClickSaveCheckList({
            detils,
            type: "kembali",
          })
        }
        loading={loading}
        showBerangkat={!isBerangkat && showBerangkat}
      />
    </div>
  );
};

export default EditorCheckListCard;
